import React, { memo } from "react";
import camelcase from "camelcase-keys";
import PropTypes from "prop-types";

import ClassificationIcon from "../../../../components/ClassificationIcon";

import { enums } from "../../../../shim/jsbridge";
import { AnalysisStatus } from "../../../../lib/enums";

const { threat_status: THREAT_STATUS_ENUM } = enums || {};

const determineClassification = (
  threatStatus,
  reanalyzing,
  notFoundView,
  stringSampleProcessingStatus
) => {
  if (notFoundView) return THREAT_STATUS_ENUM.UNKNOWN;
  if (reanalyzing || stringSampleProcessingStatus === "PROCESSING")
    return AnalysisStatus.REANALYZING;
  if (stringSampleProcessingStatus === "ERROR") return "error";
  if (stringSampleProcessingStatus === "PROCESSING")
    return AnalysisStatus.PROCESSING;

  return threatStatus;
};

const Status = ({ notFoundView, data, style }) => {
  const {
    threatStatus,
    factor,
    reanalyzing,
    stringSampleProcessingStatus,
    processingStateMessage
  } = camelcase(data || {});
  const classification = determineClassification(
    threatStatus,
    reanalyzing,
    notFoundView,
    stringSampleProcessingStatus
  );

  return (
    <ClassificationIcon
      processingStateMessage={processingStateMessage}
      classification={classification}
      riskScore={factor}
      style={style}
    />
  );
};

Status.propTypes = {
  notFoundView: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  data: PropTypes.shape({}),
  style: PropTypes.objectOf(PropTypes.string)
};

export default memo(Status);
